
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AppService } from '@app/app.service';
import { BackButtonComponent } from '@common/back-button/back-button.component';
import { SasLanguageSelectorComponent } from '@common/sas-language-selector/sas-language-selector.component';
import { SasValidationChecklistControlComponent } from '@common/sas-validation-checklist-control/sas-validation-checklist-control.component';
import { ToolbarService } from '@common/toolbar/toolbar.service';
import { TranslationService } from '@common/translation.service';
import { Language } from '@shared/interfaces/languages';
import { SasSignUserComponent } from '@shared/sas-sign-user/sas-sign-user.component';

const TRANSLATION_OPTIONS_KEY = 'LANGUAGES_OPTIONS';
const HIDE_VALIDATION_CHECKLIST_KEY = 'HIDE_VALIDATION_CHECKLIST';
const TRANSLATION_MODULE_SELECTOR = 'LANGUAGES_OPTIONS';
const UPDATE_BACK_BUTTON_EVENT = 'UPDATE_BACK_BUTTON';
const EXTERNAL_AUTHENTICATION_KEY = 'EXTERNAL_AUTHENTICATION';
const BREADCRUMB_HTML_KEY = 'BREADCRUMB_HTML';
const LANDPAGE_ROUTE = 'landpage';

@Component({
    selector: 'sas-toolbar',
    standalone: true,
    imports: [
    TranslateModule,
    BackButtonComponent,
    SasSignUserComponent,
    SasLanguageSelectorComponent,
    SasValidationChecklistControlComponent
],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})

export class ToolbarComponent {
    private appService = inject(AppService);
    private destroyRef = inject(DestroyRef);

    hideToolbar: boolean = false;
    isExternalAuthentication: boolean = false;
    stateBack: any = null;
    breadcrumbContent: SafeHtml = '';
    languages: Array<Language> = [];
    translationModule: string;
    hideValidationChecklist: boolean = false;
    toolbarService = inject(ToolbarService);

    constructor(private sanitizer: DomSanitizer, private router: Router, translationService: TranslationService) {
        this.router.events
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.hideToolbar = this.toolbarService.shouldHideToolbar(event.urlAfterRedirects);

                const showValidationChecklistControl = this.toolbarService.showValidationChecklistControl(event.urlAfterRedirects);
                this.toolbarService.updateValidationChecklistControlShow(showValidationChecklistControl);
            }
        });
        this.translationModule = TRANSLATION_MODULE_SELECTOR;
        //        this.isExternalAuthentication = this.appService.getConfiguration(EXTERNAL_AUTHENTICATION_KEY) !== undefined && this.appService.getConfiguration(EXTERNAL_AUTHENTICATION_KEY) !== null
        //          ? this.appService.getConfiguration(EXTERNAL_AUTHENTICATION_KEY)
        //        : false;
    }

    ngOnInit() {
        this.languages = this.appService.getConfiguration(TRANSLATION_OPTIONS_KEY);
        const hideValidationChecklist = this.appService.getConfiguration(HIDE_VALIDATION_CHECKLIST_KEY);
        this.hideValidationChecklist = hideValidationChecklist ?? false;

        let breadcrumbContent = this.appService.getConfigurationRaw(BREADCRUMB_HTML_KEY) || '';
        if (breadcrumbContent.length !== 0) {
            //this.breadcrumbContent = $sce.trustAsHtml($interpolate(breadcrumbContent)($scope));
            this.breadcrumbContent = this.sanitizer.bypassSecurityTrustHtml(breadcrumbContent);
        }
    }

    ngDoCheck() {
        //this.hideToolbar = $rootScope.showToolbar !== undefined ? $rootScope.showToolbar : false;
    }

    navigateBackToLandpage() {
        this.router.navigate([LANDPAGE_ROUTE]);
    }
}
